import styled, {css} from 'styled-components';
import {ReactComponent as BackArrow} from '../../assets/icons/backArrow.svg'
import {ReactComponent as Facebook} from '../../assets/icons/facebook.svg'
import {ReactComponent as Pinterest} from '../../assets/icons/pinterest.svg'
import {ReactComponent as Twitter} from '../../assets/icons/twitter.svg'
import {ReactComponent as Linkedln} from '../../assets/icons/linkedin.svg'



export const Container = styled.div`
display: flex;
flex-direction: column;
width: 100%;
box-sizing: border-box;

`

//* Wrapper common css *//

const TitleWrapper = css`
display: flex;
align-items: flex-end;
position: absolute;
bottom:50px;
left:20%;
margin: 0 200px 0 100px;
`
const TitleDesc = css`
width: 168px;
display: flex;
flex-direction: column;
margin-right: 32px;
`
const Wrap = css`
display: flex;
justify-content: space-between;
color:#fff;
font-family: Poppins;
font-style: normal;
font-weight: 600;
font-size: 12px;
line-height: 18px;

`
const Tags = css`
width: 169px;
display: flex;
flex-direction: column;
margin-right: 40px;
`
const Description = css`
margin-top: 48px;
/* padding: 0 200px; */
display: flex;
justify-content: center;
/* justify-content: space-evenly; */
`
 const Links = css`
 display: flex;
 flex-wrap: wrap;
 width: fit-content;
 `
 const BlogWrapper = css`
 margin-top: 48px;
 `
 const Desc = css`
 width: 569px;
 display: flex;
 flex-direction: column;
 `
 const iconWrapper = css`
 margin: 48px 0;
 display: flex;
 justify-content: space-between;
 align-items: center;
 
 `
 const Icon = css`
    display: flex;
    align-items: center;
    padding: 6px 12px;
    background: #F5F5F5;
    border-radius: 12px;
    cursor: pointer;
    :hover{

    background: lightGray;
    }
    :active{
        transform: scale(0.95);
        user-select: none;
    }
 `
  
 
export const Wrapper = styled.div`
display: flex;
${({wrap})=>wrap && Wrap};
position: relative;
${({titleWrapper})=>titleWrapper && TitleWrapper};
${({titleDesc})=>titleDesc && TitleDesc};
background:${({main})=>main && 'linear-gradient(0deg, #000000 0%,rgba(0, 0, 0, 0) 100%)'};
${({tags})=>tags && Tags};
${({description})=>description && Description};
${({links })=>links && Links};
${({blog})=>blog && BlogWrapper};
${({desc})=>desc && Desc};
${({icons})=>icons && Icon};
${({IconWrapper})=> IconWrapper && iconWrapper};
`

//* Title common css *//

const title = css`
font-weight: 600;
font-size: 32px;
line-height: 140%;
color: #FFFFFF;
width: 569px;
height:135px;
margin-left: 50px;
`
const Category = css`
font-weight: 600;
font-size: 12px;
line-height: 18px;
color: #A9A9A9;
margin-bottom: 12px;
`
const TitleTag = css`
font-weight: 600;
font-size: 18px;
line-height: 27px;
margin-bottom: 16px;
`
const titleTags = css`
font-weight: 600;
font-size: 12px;
line-height: 18px;
color: #6A983C;
background: #F4F8EC;
border-radius: 12px;
padding:4px 10px;
display: flex;
flex-direction: column;
margin:0 8px 8px 0;
cursor: pointer;
`
const Blog = css`
font-weight: bold;
font-size: 15px;
line-height: 22px;
cursor: pointer;
margin-left: 6px;
:hover{
text-decoration: underline;
}
`
const MainDesc = css`
font-family: Open Sans;
font-style: normal;
font-weight: normal;
font-size: 17px;
line-height: 23px;
color: #151515;
`
const MainDesc2 = css`
font-family: Open Sans;
font-style: normal;
font-weight: normal;
font-size: 17px;
line-height: 23px;
color: #151515;
margin-top: 10px;
`
const DescTitle = css`
font-weight: 600;
font-size: 18px;
line-height: 27px;
color: #151515;
margin: 48px 0 12px 0;
`
const IconDesc = css`
font-weight: 600;
font-size: 18px;
line-height: 27px;
color: #151515;
`
const IconTitle = css`
font-weight: bold;
font-size: 15px;
line-height: 22px;
color: #151515;
margin-left: 6px;

`
export const Title = styled.div`
color: #151515;
font-family: Poppins;
font-style: normal;
${({mainTitle})=>mainTitle && title};
${({category})=>category && Category};
${({titleTag})=>titleTag && TitleTag};
${({tags})=>tags && titleTags};
${({blogs})=>blogs && Blog};
${({mainDesc})=>mainDesc && MainDesc};
${({mainDesc2})=>mainDesc2 && MainDesc2};
${({descTitle})=>descTitle && DescTitle};
${({iconTitle})=>iconTitle && IconTitle};
${({iconDesc})=>iconDesc && IconDesc};
`


export const Img = styled.img`
width:100%;
border-radius: 12px;
z-index: -1;

`
export const Icons = styled.div`
`
Icons.Back = styled(BackArrow)`
cursor: pointer;
`
Icons.Facebook = styled(Facebook)`
`
 
Icons.Pinterest = styled(Pinterest)`
`
 
Icons.Twitter = styled(Twitter)`
`
 
Icons.Linkedln = styled(Linkedln)`
`
 